import { Badge } from '@chakra-ui/react'

// LessonBookingBadge — Phase 7 Plan 07-08 Task 6.
//
// Mirrors CourtRentalBadge (Plan 05-06) — distinguishes lesson-booking
// rows from event bookings and court rentals in the merged
// UpcomingEvents list.

const LessonBookingBadge = () => (
  <Badge
    bg="#3B4654"
    color="white"
    borderRadius="4px"
    px="2"
    py="1"
    fontSize="12px"
    fontWeight={500}
    textTransform="none"
  >
    Lesson
  </Badge>
)

export default LessonBookingBadge
